/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: full stack
 */
export const PROFILE_MODEL = {
    COMPANY: "COMPANY",
    EMPLOYEE: "EMPLOYEE",
    VEHICLE: "VEHICLE"
}
export const profileOptions = [
    { id: PROFILE_MODEL.COMPANY, name: 'company' },
    { id: PROFILE_MODEL.EMPLOYEE, name: 'employee' },
    { id: PROFILE_MODEL.VEHICLE, name: 'vehicle' },
];

export const DOCUMENTATION_APPROVAL_FLOW_MODEL = {
    id: null,
    serviceType: null,
    profile: '',
    levels: [],

    set: function (data) {
        const flow = { ...DOCUMENTATION_APPROVAL_FLOW_MODEL };
        flow.id = data.id || null;
        flow.serviceType = data.serviceType || null;
        flow.profile = data.profile || '';

        flow.levels = Array.isArray(data.levels)
            ? data.levels.map(level => LEVEL_MODEL.set(level))
            : [];

        return flow;
    },
    isValid: function () {
        return (
            this.serviceType !== null &&
            this.profile.trim() !== '' &&
            this.levels.length > 0
        );
    },

    hasValidLevels: function () {
        if (this.levels.length === 0) return false;

        return this.levels.every(level =>
            LEVEL_MODEL.isValid.call(level)
        );
    },

    toCreateUpdate: function () {
        return {
            id: this.id,
            serviceType: this.serviceType,
            profile: this.profile.trim(),
            levels: this.levels.map(level => level.toCreateUpdate()),
        };
    },
};

export const LEVEL_MODEL = {
    id: null,
    name: '',
    levelNumber: '',
    department: '',
    type: '',
    description: '',
    fileKey: null,
    fileUploadDto: {
        id: null,
        userFileNames: [],
        size: 0,
        filePath: '',
        storageType: 0,
    },

    isValid: function () {
        return (
            this.name.trim() !== '' &&
            this.department !== ''  &&
            this.type.trim() !== ''
        );
    },

    set: function (data) {
        const level = { ...LEVEL_MODEL };

        level.id = data.id || null;
        level.name = data.name || '';
        level.levelNumber = data.levelNumber != null ? data.levelNumber : '';
        level.department = data.department || null;
        level.type = data.type || '';
        level.description = data.description || '';
        level.fileKey = data.fileKey || null;
        level.file = data.file || null;
        level.fileName = data.fileName || null;

        if (data.fileUploadDto) {
            level.fileUploadDto = {
                id: data.fileUploadDto.id || null,
                userFileNames: Array.isArray(data.fileUploadDto.userFileNames)
                    ? [...data.fileUploadDto.userFileNames]
                    : [],
                size: data.fileUploadDto.size || 0,
                filePath: data.fileUploadDto.filePath || '',
                storageType: data.fileUploadDto.storageType || 0,
            };
        }

        return level;
    },

    toCreateUpdate: function () {
        const isTempId = typeof this.id === "string" && this.id.startsWith("tmp_");

        return {
            id: isTempId ? null : this.id,
            name: this.name.trim(),
            levelNumber: Number(this.levelNumber),
            department: this.department,
            type: this.type.trim(),
            description: this.description?.trim() || null,
            fileKey: this.fileKey
        };
    }
};
